"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefTagger = void 0;
var react_1 = require("react");
var addScript = function (setScriptAdded, language) {
    setScriptAdded(true);
    var el = document.createElement('script');
    el.type = 'text/javascript';
    el.async = true;
    var suffix = language ? "." + language + ".js" : '.js';
    el.src = "https://api.reftagger.com/v2/RefTagger" + suffix;
    document.getElementsByTagName('body')[0].appendChild(el);
};
var addRefTagger = function (settings) {
    window.refTagger = { settings: settings };
};
exports.RefTagger = function (props) {
    var _a = react_1.useState(false), scriptAdded = _a[0], setScriptAdded = _a[1];
    react_1.useEffect(function () {
        if (!scriptAdded) {
            addScript(setScriptAdded, props.language);
        }
        if (window && !window.refTagger) {
            addRefTagger(props);
        }
        if (window.refTagger && window.refTagger.tag) {
            window.refTagger.tag();
        }
    }, [scriptAdded, props]);
    return null;
};
